import { FC, ReactNode } from 'react';

import { Box, createUseVariantStyle, rem, StyleProps } from '@bonusly/design-system';

export type ColorScheme = 'blue' | 'gray' | 'green' | 'red' | 'yellow' | 'purple' | 'lightGreen' | 'lightBlue' | 'transparent';

interface Props extends StyleProps {
	children: ReactNode;
	colorScheme?: ColorScheme;
	size?: string;
}

const useVariantStyle = createUseVariantStyle({
	colorScheme: {
		blue: {
			backgroundColor: 'blue.25',
			color: 'blue.700',
		},
		gray: {
			backgroundColor: 'gray.50',
			color: 'gray.900',
		},
		green: {
			backgroundColor: 'green.400',
			color: 'green.700',
		},
		lightGreen: {
			backgroundColor: 'green.100',
		},
		lightBlue: {
			backgroundColor: 'blue.100',
		},
		red: {
			backgroundColor: 'error.bg',
			color: 'error.icon',
		},
		yellow: {
			backgroundColor: 'warning.bg',
			color: 'warning.icon',
		},
		purple: {
			backgroundColor: 'purpleAlpha.100',
			color: 'purple.600',
		},
	},
	size: {
		sm: {
			boxSize: rem(40),
		},
		md: {
			boxSize: rem(44),
		},
	},
});

export const IconChip: FC<Props> = ({ colorScheme = 'gray', size = 'md', ...rest }) => {
	return (
		<Box
			alignItems="center"
			borderRadius="full"
			display="inline-flex"
			fontSize="2xl"
			justifyContent="center"
			{...useVariantStyle({ colorScheme, size })}
			{...rest}
		/>
	);
};
